export default "__VITE_ASSET__BiJqzTnr__"